<template>
    <div>
        <div class="content content_p0" style="background: transparent !important;padding:0 0 70px 0 !important;" ref="p0index" v-for="(item,index) in 1" :key="'p0'+index">
            <div class="box_flex" style="height:1240px !important;">
                <img src="~@/assets/images/header_icon.jpg" width="100%" alt="">
                <div class="left left-one">
                    <div>
                        <div class="vip-name"><span>{{reportObj.uname}}{{bGender?'先生':'女士'}}</span></div>
                        <div class="vip-address"><span>项目地址：</span>{{reportObj.address}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content content_p1" style="background: transparent !important;padding-right:0 !important;padding-bottom:70px !important;" ref="p1index" v-for="(item,index) in 1" :key="'p1'+index">
            <div class="box_flex">
                <img src="~@/assets/images/fate_icon.jpg" alt="">
                <div class="left">
                    <div>
                        <div class="vip-name"><span>{{reportObj.uname}}{{bGender?'先生':'女士'}}</span></div>
                        <div class="vip-address"><span>项目地址：</span>{{reportObj.address}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content content_p2" ref="p2index" v-for="(item,index) in 1" :key="'p2'+index">
            <div class="top-img-two">项目信息&需求分析</div>
            <div class="box">
                <div class="middle">
                    <div class="centent_left">
                        <div class="middle-left">
                            <div class="middle-left-top">
                                <div class="num">
                                    <span>01</span>
                                    <div class="square"></div>
                                </div>
                                <div class="title">房屋勘察情况</div>
                                <div class="line"></div>
                            </div>
                            <div class="middle-left-bottom">
                                <div class="num"></div>
                                <div class="details">
                                    <table>
                                        <tr>
                                            <td class="details-color" width="70">
                                                户型
                                            </td>
                                            <td width="190">
                                                {{ reportObj.house_type }}
                                            </td>
                                            <td class="details-color" width="70">
                                                规划
                                            </td>
                                            <td width="220">
                                                {{ reportObj.house_layout }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="details-color">面积</td>
                                            <td>{{ reportObj.area + "㎡" }}</td>
                                            <td class="details-color">层高</td>
                                            <td>{{ reportObj.floor + "m" }}</td>
                                        </tr>
                                        <tr>
                                            <td class="details-color">保温</td>
                                            <td colspan="3">
                                                {{ reportObj.warm_state_text }}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="middle-left">
                            <div class="middle-left-top">
                                <div class="num">
                                    <span>03</span>
                                    <div class="square"></div>
                                </div>
                                <div class="title">设计依据</div>
                                <div class="line"></div>
                            </div>
                            <div class="middle-left-bottom">
                                <div class="num"></div>
                                <div class="type_list">
                                    <div class="type_item">
                                        <div>GB50736</div>
                                        <div>
                                            《民用建筑供暖通风与空气调节设计规范》
                                        </div>
                                    </div>
                                    <div class="type_item">
                                        <div>GB50189</div>
                                        <div>《公共建筑节能设计标准》</div>
                                    </div>
                                    <div class="type_item">
                                        <div>GB50015</div>
                                        <div>《建筑给水排水设计标准》</div>
                                    </div>
                                    <div class="type_item">
                                        <div>GB25034</div>
                                        <div>《燃气采暖热水炉》</div>
                                    </div>
                                    <div class="type_item">
                                        <div>GB50028</div>
                                        <div>《城镇燃气设计规范》</div>
                                    </div>
                                    <div class="type_item">
                                        <div>GB50243</div>
                                        <div>
                                            《通风与空调工程施工质量验收规范》
                                        </div>
                                    </div>
                                    <div class="type_item">
                                        <div>GB50242</div>
                                        <div>
                                            《建筑给水排水及采暖工程施工质量验收规范》
                                        </div>
                                    </div>
                                    <div class="type_item">
                                        <div>JGJ134</div>
                                        <div>
                                            《夏热冬冷地区居住建筑节能设计标准》
                                        </div>
                                    </div>
                                    <div class="type_item">
                                        <div>JGJ142</div>
                                        <div>《辐射供暖供冷技术规程》</div>
                                    </div>
                                    <div class="type_item">
                                        <div>CJJ12</div>
                                        <div>
                                            《家用燃气燃烧器具安装及验收规程》
                                        </div>
                                    </div>
                                    <div class="type_item">
                                        <div>CJJ94</div>
                                        <div>
                                            《城镇燃气室内施工与质量验收规范》
                                        </div>
                                    </div>
                                    <div class="type_item">
                                        <div>CJ/T395</div>
                                        <div>《冷凝式燃气采暖热水炉》</div>
                                    </div>
                                    <div class="type_item">
                                        <div>T/CECA-G0095</div>
                                        <div>
                                            《空气源热泵和燃气热水炉复合能源智能舒适系统技术规范》
                                        </div>
                                    </div>
                                    <div class="type_item">
                                        <div>T/CECS215</div>
                                        <div>《燃气采暖热水炉应用技术规程》</div>
                                    </div>
                                    <div class="type_item">
                                        <div>12K404</div>
                                        <div>《地暖辐射供暖系统施工安装》</div>
                                    </div>
                                    <div class="type_item">
                                        <div></div>
                                        <div>
                                            《全国民用建筑工程设计技术措施—暖通空调·动力》
                                        </div>
                                    </div>
                                    <div class="type_item">
                                        <div></div>
                                        <div>
                                            《全国民用建筑工程设计技术措施给水排水》
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="middle-right">
                        <div class="middle-left-top">
                            <div class="num">
                                <span>02</span>
                                <div class="square"></div>
                            </div>
                            <div class="title">系统定制需求</div>
                            <div class="line"></div>
                        </div>
                        <div class="middle-left-bottom">
                            <div class="num"></div>
                            <div class="type_list">
                                <div
                                    class="type_warp"
                                    v-for="(item, index) in reportObj.tags"
                                    :key="index"
                                >
                                    <p class="type_title">{{ item.type_name }}：</p>
                                    <div
                                        class="type_text"
                                        v-html="
                                            item.type_desc == ''
                                                ? item.strDeas
                                                : item.type_desc
                                        "
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div>
                    <p>
                        * 设计依据：T/CECA-G0095
                        《空气源热泵和燃气热水炉复合能源智能舒适系统技术规范》
                    </p>
                </div>
            </div>
        </div>
        <div :class="['headder','content_p3'+index]" :ref="'p3index'+index" v-for="(item,index) in reportObj.arrRoomEnd" :key="'p3'+index">
            <div class="top-img-two">冷暖系统选型配置</div>
            <div class="box">
                <div class="middle" v-if="index==0">
                    <div class="middle-left">
                        <div class="middle-left-top">
                            <div class="num">
                                <span>01</span>
                                <div class="square"></div>
                            </div>
                            <div class="title">系统设计参数</div>
                            <div class="line"></div>
                        </div>
                        <div class="middle-left-bottom">
                            <div class="num"></div>
                            <div class="details">
                                <table>
                                    <tr>
                                        <td class="details-color" width="170">
                                            空调面积
                                        </td>
                                        <td width="150">
                                            {{ reportObj.hotOrcatArea }}㎡
                                        </td>
                                        <td class="details-color" width="170">
                                            采暖面积
                                        </td>
                                        <td width="150">
                                            {{ reportObj.hotOrcatArea }}㎡
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="details-color">需求负荷</td>
                                        <td>
                                            冷{{
                                                (
                                                    reportObj.endRoom_cut / 1000
                                                ).toFixed(2) + "kw"
                                            }}
                                        </td>
                                        <td class="details-color">需求负荷</td>
                                        <td>
                                            暖{{
                                                (
                                                    reportObj.endRoom_hot / 1000
                                                ).toFixed(2) + "kw"
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="details-color">设计负荷</td>
                                        <td>
                                            冷{{
                                                (
                                                    (reportObj.energy_cold / 1000) / reportObj.roomsArea
                                                ).toFixed(2) + "kw/㎡"
                                            }}
                                        </td>
                                        <td class="details-color">设计负荷</td>
                                        <td>
                                            暖{{
                                                (
                                                    reportObj.energy_hot / 1000 / reportObj.roomsArea
                                                ).toFixed(2) + "kw/㎡"
                                            }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="details-color">保温情况</td>
                                        <td>{{ reportObj.warm_state }}</td>
                                        <td class="details-color">
                                            末端同开率
                                        </td>
                                        <td>
                                            {{
                                                reportObj.nPercentNum /
                                                reportObj.sub.length
                                            }}%
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="details-color" colspan="2">
                                            当地冬季平均最低气温
                                        </td>
                                        <td>
                                            {{
                                                reportObj.temperature_avg + "℃"
                                            }}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="middle-right">
                        <div class="middle-left-top">
                            <div class="num">
                                <span>02</span>
                                <div class="square"></div>
                            </div>
                            <div class="title">系统设备配置</div>
                            <div class="line"></div>
                        </div>
                        <div class="middle-right-bottom">
                            <div class="num"></div>
                            <div class="list" style="margin: 0 !important;">
                                <div
                                    class="list-warp"
                                    v-for="(
                                        item, index
                                    ) in reportObj.arrCodsystem"
                                    :key="index"
                                    v-show="item.new_goods_type_id==214"
                                >
                                    <div class="list-content">
                                        <div class="list-top">
                                            <img :src="item.mobile_img" />
                                        </div>
                                        <div class="list-bottom">
                                            {{ 'AI-LiNK智能物联系统' }}
                                        </div>
                                        <!-- <div class="list-bottom-att" v-show="item.attr_two.length">
                                            <div v-for="(attitem,attindex) in item.attr_two" :key="attindex">
                                                <span>{{attitem.attr_name+':'+attitem.attr_value+'kw'}}</span>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="list-warp-right">
                                    <div class="list-img">
                                        <img :src="reportObj.arrAilink[0].mobile_img" alt="">
                                    </div>
                                    <div class="list-type">
                                        <div class="list-type-left">
                                            <div>型号</div>
                                            <div>设备制冷量</div>
                                            <div>设备制热量</div>
                                            <div>台数</div>
                                        </div>
                                        <div class="list-type-right">
                                            <div>{{reportObj.arrAilink[0].goods_name}}</div>
                                            <div v-for="(attitem,attindex) in reportObj.arrAilink[0].attr_two" :key="attindex">{{attitem.attr_value}}</div>
                                            <div>{{reportObj.arrAilink.length}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bottom">
                    <div class="middle-left-top">
                        <div class="num">
                            <span>03</span>
                            <div class="square"></div>
                        </div>
                        <div class="title">末端设备配置</div>
                        <div class="line"></div>
                    </div>
                    <div class="bottom-content">
                        <div class="num"></div>
                        <div class="bottom-details">
                            <div class="table_list">
                                <!-- <div class="tabel_td" style="width:6%;">
                                    楼层
                                </div> -->
                                <div class="tabel_td" style="width:4%;">
                                    功能区
                                </div>
                                <div class="tabel_td" style="width:4%;">
                                    面积㎡
                                </div>
                                <div class="tabel_td" style="width:4%;">
                                    朝向
                                </div>
                                <div class="tabel_td" style="width:4%;">
                                    层高m
                                </div>
                                <div class="tabel_td" style="width:6%;">
                                    设计温度℃
                                </div>
                                <div class="tabel_td" style="width:8%;">
                                    需求冷负荷kw
                                </div>
                                <div class="tabel_td" style="width:8%;">
                                    设计冷负荷w/㎡
                                </div>
                                <div class="tabel_td" style="width:8%;">
                                    需求制热量kw
                                </div>
                                <div class="tabel_td" style="width:8%;">
                                    设计热负荷w/㎡
                                </div>
                                <div class="tabel_td" style="width:9%;">
                                    末端设备
                                </div>
                                <div class="tabel_td" style="width:13%;">
                                    设备型号
                                </div>
                                <div class="tabel_td" style="width:3%;">
                                    数量
                                </div>
                                <div class="tabel_td" style="width:6%;">
                                    单位负荷w
                                </div>
                                <div class="tabel_td" style="width:7.5%;">
                                    设备制冷量kw
                                </div>
                                <div class="tabel_td" style="width:7.5%;">
                                    设备制热量kw
                                </div>
                            </div>
                            <div>
                                <div :class="['shopp_list',indexs%2 ==0?'rooms-td-two':'']" v-for="(items,indexs) in item" :key="indexs">
                                    <!-- <div class="rooms_td" style="width:6%;">
                                        <div class="rooms_sub">{{item.room | roomNumber }}</div>
                                    </div> -->
                                    <div :class="['rooms_td']" style="width:100%;">
                                        <div class="rooms_td_list" >
                                            <!-- v-for="(ritem,rindex) in item.rooms" :key="rindex" -->
                                            <div class="rooms_td_item" style="width:4%;">{{items.name}}</div>
                                            <div class="rooms_td_item" style="width:4%;">{{items.area}}</div>
                                            <div class="rooms_td_item" style="width:4%;">{{items.direction | nDirection}}</div>
                                            <div class="rooms_td_item" style="width:4%;">{{items.floor}}</div>
                                            <div class="rooms_td_item" style="width:6%;">{{items.temperature}}</div>
                                            <div class="rooms_td_item" style="width:8%;">{{(items.energy_cold/1000).toFixed(2)}}</div>
                                            <div class="rooms_td_item" style="width:8%;">{{((items.energy_cold)/items.area).toFixed(2)}}</div>
                                            <div class="rooms_td_item" style="width:8%;">{{(items.energy_hot/1000).toFixed(2)}}</div>
                                            <div class="rooms_td_item" style="width:8%;">{{((items.energy_hot)/items.area).toFixed(2)}}</div>
                                            <div :class="['rooms_td_item_shopp',items.product&&indexs%2 ==0?'rooms_back':'']" style="width:46%;">
                                                <div class="shopp_td_item" style="width:100%;" v-for="(pitem,pindex) in items.shoppGoods" :key="pindex">
                                                    <div class="shopp_td_item_warp" style="width:19.5%;" v-if="pitem.new_goods_type_id!=216">
                                                        <div>{{pitem.new_goods_type_name}}</div>
                                                    </div>
                                                    <div class="shopp_td_item_warp" style="width:19.5%;" v-if="pitem.new_goods_type_id==216">
                                                        <div>{{pitem.goods_name}}</div>
                                                    </div>
                                                    <div class="shopp_td_item_warp" style="width:28.3%;">
                                                        <div>{{pitem.goods_name?pitem.goods_name:'--'}}</div>
                                                    </div>
                                                    <div class="shopp_td_item_warp" style="width:6.6%;">
                                                        <div>{{pitem.num?pitem.num:'--'}}</div>
                                                    </div>
                                                    <div class="shopp_td_item_warp" style="width:13%;">
                                                        <div>{{pitem.power?pitem.power:'--'}}</div>
                                                    </div>
                                                    <div class="shopp_td_item_warp" style="width:16.2%;">
                                                        {{pitem.attr_two.length?pitem.attr_two[0].attr_value>100?(Number(pitem.attr_two[0].attr_value)/1000).toFixed(1):pitem.attr_two[0].attr_value:'--'}}
                                                    </div>
                                                    <div class="shopp_td_item_warp" style="width:16.2%;">
                                                        {{pitem.attr_two.length==2?pitem.attr_two[1].attr_value:'--'}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div>
                    <p>
                        * 设计依据：T/CECA-G0095
                        《空气源热泵和燃气热水炉复合能源智能舒适系统技术规范》
                    </p>
                </div>
            </div>
        </div>
        <div class="content content_p4" ref="p4index" v-if="false">
            <div class="top-img-two">冷暖系统选型配置</div>
            <div class="box">
                <div class="middle_p4">
                    <div class="middle-left-p4">
                        <div class="middle-left-top">
                            <div class="num">
                                <span>01</span>
                                <div class="square"></div>
                            </div>
                            <div class="title">系统设计参数</div>
                            <div class="line"></div>
                        </div>
                        <div class="middle-left-bottom">
                            <div class="num"></div>
                            <div class="details">
                                <table>
                                    <tr>
                                        <td class="details-color" width="100">
                                            空调面积
                                        </td>
                                        <td width="135">{{ reportObj.energy_hot_area }}㎡</td>
                                        <td class="details-color" width="100">
                                            采暖面积
                                        </td>
                                        <td width="135">{{ reportObj.energy_hot_area }}㎡</td>
                                        <td class="details-color" width="100">
                                            保温情况
                                        </td>
                                        <td width="135">
                                            {{ reportObj.warm_state }}
                                        </td>
                                        <td class="details-color" width="100">
                                            末端同开率
                                        </td>
                                        <td width="135">
                                            {{
                                                reportObj.nPercentNum /
                                                reportObj.sub.length
                                            }}%
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="details-color" width="100">
                                            需求负荷
                                        </td>
                                        <td width="135">冷{{
                                                    (
                                                        reportObj.energy_cold / 1000
                                                    ).toFixed(1) + "kw"
                                                }}</td>
                                        <td class="details-color" width="100">
                                            需求负荷
                                        </td>
                                        <td width="135">暖{{
                                                    (
                                                        reportObj.energy_hot / 1000
                                                    ).toFixed(1) + "kw"
                                                }}</td>
                                        <td class="details-color" width="212">
                                            当地冬季平均最低气温
                                        </td>
                                        <td width="135">
                                            {{
                                                reportObj.temperature_avg + "℃"
                                            }}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="middle-right-p4">
                        <div class="middle-left-top">
                            <div class="num">
                                <span>02</span>
                                <div class="square"></div>
                            </div>
                            <div class="title">系统设备配置</div>
                            <div class="line"></div>
                        </div>
                        <div class="middle-right-bottom">
                            <div class="num"></div>
                            <div class="list">
                                <div
                                    class="list-warp"
                                    style="width:13%;"
                                    v-for="(
                                        item, index
                                    ) in reportObj.arrCodsystem"
                                    :key="index"
                                    >
                                    <div class="list-content">
                                        <div class="list-top">
                                            <img
                                                class="equipment"
                                                :src="item.mobile_img"
                                                alt=""
                                            />
                                        </div>
                                        <div class="list-bottom">
                                            {{ item.goods_name }}
                                        </div>
                                        <div class="list-bottom-att">
                                            <div v-for="(attitem,attindex) in item.attr_two" :key="attindex">
                                                <span>{{attitem.attr_name+':'+attitem.attr_value+'kw'}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div>
                    <p>
                        * 设计依据：T/CECA-G0095
                        《空气源热泵和燃气热水炉复合能源智能舒适系统技术规范》
                    </p>
                </div>
            </div>
        </div>
        <!-- :ref="'p5index'+index" v-for="(item,index) in reportObj.arrRoomsThree" :key="'p5'+index" -->
        <div :class="['content','content_p5'+index]" v-if="false">
            <div class="top-img-two">冷暖系统选型配置</div>
            <div class="box">
                <div class="bottom">
                    <div class="middle-left-top">
                        <div class="num">
                            <span>03</span>
                            <div class="square"></div>
                        </div>
                        <div class="title">末端设备配置</div>
                        <div class="line"></div>
                    </div>
                    <div class="bottom-content">
                        <div class="num"></div>
                        <div class="bottom-details">
                            <div class="table_list">
                                <!-- <div class="tabel_td" style="width:6%;">
                                    楼层
                                </div> -->
                                <div class="tabel_td" style="width:5%;">
                                    功能区
                                </div>
                                <div class="tabel_td" style="width:5%;">
                                    面积㎡
                                </div>
                                <div class="tabel_td" style="width:5%;">
                                    朝向
                                </div>
                                <div class="tabel_td" style="width:5%;">
                                    层高m
                                </div>
                                <div class="tabel_td" style="width:7%;">
                                    设计温度℃
                                </div>
                                <div class="tabel_td" style="width:9%;">
                                    需求冷负荷kw
                                </div>
                                <div class="tabel_td" style="width:9%;">
                                    设计冷负荷w/㎡
                                </div>
                                <div class="tabel_td" style="width:9%;">
                                    需求制热量kw
                                </div>
                                <div class="tabel_td" style="width:9%;">
                                    设计热负荷w/㎡
                                </div>
                                <div class="tabel_td" style="width:19%;">
                                    末端设备
                                </div>
                                <div class="tabel_td" style="width:19%;">
                                    设备型号
                                </div>
                                <div class="tabel_td" style="width:9%;">
                                    设备制热量kw
                                </div>
                                <div class="tabel_td" style="width:9%;">
                                    设备制热量kw
                                </div>
                            </div>
                            <div>
                                <div :class="['shopp_list',indexs%2 ==0?'rooms-td-two':'']" v-for="(items,indexs) in item" :key="indexs">
                                    <!-- <div class="rooms_td" style="width:6%;">
                                        <div class="rooms_sub">{{item.room | roomNumber }}</div>
                                    </div> -->
                                    <div :class="['rooms_td']" style="width:100%;">
                                        <div class="rooms_td_list" >
                                            <!-- v-for="(ritem,rindex) in item.rooms" :key="rindex" -->
                                            <div class="rooms_td_item" style="width:5%;">{{items.name}}</div>
                                            <div class="rooms_td_item" style="width:5%;">{{items.area}}</div>
                                            <div class="rooms_td_item" style="width:5%;">{{items.direction | nDirection}}</div>
                                            <div class="rooms_td_item" style="width:5%;">{{items.floor}}</div>
                                            <div class="rooms_td_item" style="width:7%;">{{items.temperature}}</div>
                                            <div class="rooms_td_item" style="width:9%;">{{((items.energy_cold)/items.area).toFixed(2)}}</div>
                                            <div class="rooms_td_item" style="width:9%;">{{items.energy_cold/1000}}</div>
                                            <div class="rooms_td_item" style="width:9%;">{{((items.energy_hot)/items.area).toFixed(2)}}</div>
                                            <div class="rooms_td_item" style="width:9%;">{{items.energy_hot/1000}}</div>
                                            <div :class="['rooms_td_item_shopp',items.product&&indexs%2 ==0?'rooms_back':'']" style="width:37%;">
                                                <div class="shopp_td_item" style="width:100%;" v-for="(pitem,pindex) in items.product" :key="pindex">
                                                    <div class="shopp_td_item_warp" style="width:11.2%;">
                                                        <div>{{pitem.mark?pitem.mark:'--'}}</div>
                                                    </div>
                                                    <div class="shopp_td_item_warp" style="width:41.2%;">
                                                        <div>{{pitem.mark?pitem.mark:'--'}}<br v-if="pitem.mark">{{pitem.mark?pitem.mark:'--'}}</div>
                                                    </div>
                                                    <div class="shopp_td_item_warp" style="width:24.4%;">
                                                        {{pitem.attr_two.length?pitem.attr_two[1].attr_value:'--'}}
                                                    </div>
                                                    <div class="shopp_td_item_warp" style="width:24.4%;">
                                                        {{pitem.attr_two.length?pitem.attr_two[0].attr_value:'--'}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div>
                    <p>
                        * 设计依据：T/CECA-G0095
                        《空气源热泵和燃气热水炉复合能源智能舒适系统技术规范》
                    </p>
                </div>
            </div>
        </div>
        <div class="content content_p6" v-if="false">
            <div class="top-img-two">水系统选型配置</div>
            <div class="box">
                <div class="middle">
                    <div class="middle-left">
                        <div class="middle-left-top">
                            <div class="num">
                                <span>01</span>
                                <div class="square"></div>
                            </div>
                            <div class="title">系统设计参数</div>
                            <div class="line"></div>
                        </div>
                        <div class="middle-left-bottom">
                            <div class="num"></div>
                            <div class="details">
                                <table>
                                    <tr>
                                        <td class="details-color" width="172">
                                            用水点
                                        </td>
                                        <td width="105">
                                            {{ reportObj.numToilet ? reportObj.numToilet + "卫" : "0卫"
                                            }}{{
                                            reportObj.numKitchen ? reportObj.numKitchen + "厨" : "0厨"
                                            }}
                                        </td>
                                        <td class="details-color" width="172">
                                            洗浴习惯
                                        </td>
                                        <td width="135">{{ reportObj.bath_habit }}</td>
                                    </tr>
                                    <tr>
                                        <td class="details-color">用水人数</td>
                                        <td width="135">{{
                                            reportObj.config_num ? reportObj.config_num + "人" : ""
                                            }}
                                        </td>
                                        <td class="details-color">
                                            热水设计流量
                                        </td>
                                        <td>{{(Number(reportObj.nWaterRate)/Number(reportObj.sub.length)).toFixed(2)}}L/min</td>
                                    </tr>
                                    <tr>
                                        <td class="details-color">
                                            冬季进水温度
                                        </td>
                                        <td>
                                            {{
                                                Number(reportObj.water_cold).toFixed(1) + "℃"
                                            }}
                                        </td>
                                        <td class="details-color">
                                            热水需求负荷
                                        </td>
                                        <td>{{(Number(reportObj.nWaterEnergy)/Number(reportObj.sub.length)).toFixed(2)}}kw</td>
                                    </tr>
                                    <tr>
                                        <td class="details-color">
                                            最大净水用量
                                        </td>
                                        <td>{{(Number(reportObj.nWaterClean)/Number(reportObj.sub.length)).toFixed(2)}}t/h</td>
                                        <td class="details-color">
                                            最大软水用量
                                        </td>
                                        <td>{{(Number(reportObj.nWaterSoft)/Number(reportObj.sub.length)).toFixed(2)}}t/h</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="middle-right">
                        <div class="middle-left-top">
                            <div class="num">
                                <span>02</span>
                                <div class="square"></div>
                            </div>
                            <div class="title">系统设备配置</div>
                            <div class="line"></div>
                        </div>
                        <div class="middle-right-bottom">
                            <div class="num"></div>
                            <div class="list">
                                <div
                                    class="list-warp"
                                    v-for="(
                                        item, index
                                    ) in reportObj.arrWater"
                                    v-show="index<4"
                                    :key="index"
                                >
                                    <div class="list-content">
                                        <div class="list-top">
                                            <img
                                                class="equipment"
                                                :src="item.mobile_img"
                                                alt=""
                                            />
                                        </div>
                                        <div class="list-bottom">
                                            {{item.goods_name}}
                                        </div>
                                        <div class="list-bottom-att">
                                            <div v-for="(attitem,attindex) in item.attr_two" :key="attindex">
                                                <span>{{attitem.attr_name+':'+attitem.attr_value+'kw'}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="middle-left-top">
                        <div class="num">
                            <span>03</span>
                            <div class="square"></div>
                        </div>
                        <div class="title">系统设备配置依据</div>
                        <div class="line"></div>
                    </div>
                    <div class="bottom-content">
                        <div class="num"></div>
                        <div>
                            <div class="left">
                                <p style="font-size: 20px;">热水流量计算公式：Qr = c * ρ* (qr/60) * (tr-tl)</p>
                                <div class="formula">
                                    <div class="travel">
                                        <div>Qr</div>
                                        <div>—— 热水负荷</div>
                                        <div>kw</div>
                                    </div>
                                    <div class="travel">
                                        <div>c</div>
                                        <div>—— 水的比热，c=4.187</div>
                                        <div>kj/(kg ℃)</div>
                                    </div>
                                    <div class="travel">
                                        <div>ρ</div>
                                        <div>—— 热水密度，通常为1</div>
                                        <div>kg/L</div>
                                    </div>
                                    <div class="travel">
                                        <div>qr</div>
                                        <div>—— 热水设计温度</div>
                                        <div>L/min</div>
                                    </div>
                                    <div class="travel">
                                        <div>tr</div>
                                        <div>—— 热水计算温度</div>
                                        <div>℃</div>
                                    </div>
                                    <div class="travel">
                                        <div>tl</div>
                                        <div>—— 热水计算温度</div>
                                        <div>℃</div>
                                    </div>
                                </div>
                            </div>
                            <div class="right">
                                <p style="font-size: 20px;">净水用量计算公式： q = n* 0.5t/h </p>
                                <div class="formula">
                                    <div class="travel">
                                        <div>q</div>
                                        <div>—— 最大净水用水量</div>
                                    </div>
                                    <div class="travel">
                                        <div>n</div>
                                        <div>—— 卫生间数量</div>
                                    </div>
                                    <div class="travel">
                                        <div>0.5t/h</div>
                                        <div>
                                            ——
                                            单个卫生间用水量0.15(L/s)×1×0.75=0.4t/h，取0.5t/h
                                        </div>
                                    </div>
                                </div>
                                <p style="margin-top: 20px;font-size: 20px;">
                                    软水用量计算公式： q = n* 0.5t/h
                                </p>
                                <div class="formula">
                                    <div class="travel">
                                        <div>q</div>
                                        <div>—— 最大软水用水量</div>
                                    </div>
                                    <div class="travel">
                                        <div>n</div>
                                        <div>—— 卫生间数量</div>
                                    </div>
                                    <div class="travel">
                                        <div>0.5t/h</div>
                                        <div>
                                            ——
                                            单个卫生间用水量0.15(L/s)×1×0.75=0.4t/h，取0.5t/h
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div>
                    <p>
                        * 设计依据：T/CECA-G0095
                        《空气源热泵和燃气热水炉复合能源智能舒适系统技术规范》
                    </p>
                </div>
            </div>
        </div>
        <div class="content content_p6" ref="p6index" v-for="(item,index) in 1" :key="'p6'+index">
            <div class="top-img-two">水系统选型配置</div>
            <div class="box">
                <div class="middle_p4">
                    <div class="middle-left-p4">
                        <div class="middle-left-top">
                            <div class="num">
                                <span>01</span>
                                <div class="square"></div>
                            </div>
                            <div class="title">系统设计参数</div>
                            <div class="line"></div>
                        </div>
                        <div class="middle-left-bottom">
                            <div class="num"></div>
                            <div class="details">
                                <table>
                                    <tr>
                                        <td class="details-color" width="190">
                                            用水点
                                        </td>
                                        <td width="170">
                                            {{ reportObj.numToilet ? reportObj.numToilet + "卫" : "0卫"
                                            }}{{
                                            reportObj.numKitchen ? reportObj.numKitchen + "厨" : "0厨"
                                            }}
                                        </td>
                                        <td class="details-color" width="190">
                                            洗浴习惯
                                        </td>
                                        <td width="170">{{ reportObj.bath_habit }}</td>
                                        <td class="details-color" width="190">用水人数</td>
                                        <td width="170">{{
                                            reportObj.config_num ? reportObj.config_num + "人" : ""
                                            }}
                                        </td>
                                        <td class="details-color" width="190">
                                            热水设计流量
                                        </td>
                                        <td>{{(Number(reportObj.nWaterRate)/Number(reportObj.sub.length)).toFixed(2)}}L/min</td>
                                    </tr>
                                    <tr>
                                        <td class="details-color">
                                            冬季进水温度
                                        </td>
                                        <td>
                                            {{
                                                Number(reportObj.water_cold).toFixed(1) + "℃"
                                            }}
                                        </td>
                                        <td class="details-color">
                                            热水需求负荷
                                        </td>
                                        <td>{{(Number(reportObj.nWaterEnergy)/Number(reportObj.sub.length)).toFixed(2)}}kw</td>
                                        <td class="details-color">
                                            最大净水用量
                                        </td>
                                        <td>{{(Number(reportObj.nWaterClean)/Number(reportObj.sub.length)).toFixed(2)}}t/h</td>
                                        <td class="details-color">
                                            最大软水用量
                                        </td>
                                        <td>{{(Number(reportObj.nWaterSoft)/Number(reportObj.sub.length)).toFixed(2)}}t/h</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="middle-right-p4">
                        <div class="middle-left-top">
                            <div class="num">
                                <span>02</span>
                                <div class="square"></div>
                            </div>
                            <div class="title">系统设备配置</div>
                            <div class="line"></div>
                        </div>
                        <div class="middle-right-bottom">
                            <div class="num"></div>
                            <div class="list">
                                <div
                                    class="list-warp"
                                    style="width:13%;"
                                    v-for="(
                                        item, index
                                    ) in reportObj.arrQuanWater"
                                    v-show="index<8"
                                    :key="index"
                                >
                                    <div class="list-content">
                                        <div class="list-top">
                                            <img
                                                class="equipment"
                                                :src="item.mobile_img"
                                                alt=""
                                            />
                                        </div>
                                        <div class="list-bottom">
                                            {{item.goods_name}}
                                        </div>
                                        <div class="list-bottom-att">
                                            <div v-for="(attitem,attindex) in item.attr_two" :key="attindex">
                                                <span>{{attitem.attr_name+':'+attitem.attr_value+'kw'}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="middle-left-top">
                        <div class="num">
                            <span>03</span>
                            <div class="square"></div>
                        </div>
                        <div class="title">系统设备配置依据</div>
                        <div class="line"></div>
                    </div>
                    <div class="bottom-content">
                        <div class="num"></div>
                        <div style="display:flex;width:100%;justify-content: space-between;">
                            <div class="left">
                                <p style="font-size: 20px;">热水流量计算公式：Qr = c * ρ* (qr/60) * (tr-tl)</p>
                                <div class="formula">
                                    <div class="travel">
                                        <div>Qr</div>
                                        <div>—— 热水负荷</div>
                                        <div>kw</div>
                                    </div>
                                    <div class="travel">
                                        <div>c</div>
                                        <div>—— 水的比热，c=4.187</div>
                                        <div>kj/(kg ℃)</div>
                                    </div>
                                    <div class="travel">
                                        <div>ρ</div>
                                        <div>—— 热水密度，通常为1</div>
                                        <div>kg/L</div>
                                    </div>
                                    <div class="travel">
                                        <div>qr</div>
                                        <div>—— 热水设计温度</div>
                                        <div>L/min</div>
                                    </div>
                                    <div class="travel">
                                        <div>tr</div>
                                        <div>—— 热水计算温度</div>
                                        <div>℃</div>
                                    </div>
                                    <div class="travel">
                                        <div>tl</div>
                                        <div>—— 热水计算温度</div>
                                        <div>℃</div>
                                    </div>
                                </div>
                            </div>
                            <div class="right">
                                <p style="font-size: 20px;">净水用量计算公式： q = n* 0.5t/h </p>
                                <div class="formula">
                                    <div class="travel">
                                        <div>q</div>
                                        <div>—— 最大净水用水量</div>
                                    </div>
                                    <div class="travel">
                                        <div>n</div>
                                        <div>—— 卫生间数量</div>
                                    </div>
                                    <div class="travel">
                                        <div>0.5t/h</div>
                                        <div>
                                            ——
                                            单个卫生间用水量0.15(L/s)×1×0.75=0.4t/h，取0.5t/h
                                        </div>
                                    </div>
                                </div>
                                <p style="margin-top: 20px;font-size: 20px;">
                                    软水用量计算公式： q = n* 0.5t/h
                                </p>
                                <div class="formula">
                                    <div class="travel">
                                        <div>q</div>
                                        <div>—— 最大软水用水量</div>
                                    </div>
                                    <div class="travel">
                                        <div>n</div>
                                        <div>—— 卫生间数量</div>
                                    </div>
                                    <div class="travel">
                                        <div>0.5t/h</div>
                                        <div>
                                            ——
                                            单个卫生间用水量0.15(L/s)×1×0.75=0.4t/h，取0.5t/h
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div>
                    <p>
                        * 设计依据：T/CECA-G0095
                        《空气源热泵和燃气热水炉复合能源智能舒适系统技术规范》
                    </p>
                </div>
            </div>
        </div>
        <div :class="['content','content_p7'+index]" :ref="'p7index'+index" v-for="(item,index) in reportObj.arrGoodsFater" :key="'p7'+index">
            <div class="top-img-two">新风系统选型配置</div>
            <div class="box">
                <div class="middle">
                    <div class="middle-left">
                        <div class="middle-left-top">
                            <div class="num">
                                <span>01</span>
                                <div class="square"></div>
                            </div>
                            <div class="title">系统设计参数</div>
                            <div class="line"></div>
                        </div>
                        <div class="middle-left-bottom" v-for="(minitem,minindex) in item.arrMoth" :key="minindex">
                            <div class="num"></div>
                            <div class="details">
                                <table>
                                    <tr>
                                        <td class="details-color" width="230">
                                            楼层
                                        </td>
                                        <td width="135">
                                            {{ minitem.room | roomNumber}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="details-color" width="230">
                                            风口数量
                                        </td>
                                        <td width="135">
                                            {{ minitem.numWindKou }}个
                                        </td>
                                        <td class="details-color" width="230">
                                            换气面积
                                        </td>
                                        <td width="135">
                                            {{ minitem.wind_area }}㎡
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="details-color">换气次数</td>
                                        <td>{{ minitem.wind_exchange }}次/小时</td>
                                        <td class="details-color">新风需求风量</td>
                                        <td>{{ minitem.wind_energy }}m³/hp</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="middle-right">
                        <div class="middle-left-top">
                            <div class="num">
                                <span>02</span>
                                <div class="square"></div>
                            </div>
                            <div class="title">系统设备配置</div>
                            <div class="line"></div>
                        </div>
                        <div class="middle-right-bottom">
                            <div class="num"></div>
                            <div class="list">
                                <div
                                    class="list-warp"
                                    v-for="(
                                        items, indexs
                                    ) in reportObj.arrFater"
                                    v-show="indexs<1"
                                    :key="indexs"
                                    >
                                    <div class="list-content">
                                        <div class="list-top">
                                            <img
                                                class="equipment"
                                                :src="items.mobile_img"
                                                alt=""
                                            />
                                        </div>
                                        <div class="list-bottom">
                                            {{items.new_goods_type_name}}
                                        </div>
                                    </div>
                                </div>
                                <div class="shopp_list">
                                    <div class="shopp_warp">
                                        <div>产品型号</div>
                                        <div>风量</div>
                                        <div>冷热回收率</div>
                                        <div>PM2.5过滤率</div>
                                    </div>
                                    <div class="shopp_warp_td" :class="[subindex%2 ==0?'':'shopp_warp_td_two']" v-for="(subitem,subindex) in item.arrMothGoods" :key="subindex">
                                        <div>{{subitem.goods_name}}</div>
                                        <div v-for="(attitem,attindex) in subitem.attr_two" :key="attindex">{{attitem.attr_value}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="middle-left-top">
                        <div class="num">
                            <span>03</span>
                            <div class="square"></div>
                        </div>
                        <div class="title">系统设备配置依据</div>
                        <div class="line"></div>
                    </div>
                    <div class="bottom-content">
                        <div style="width:100%;">
                            <div class="bottom_txt" style="padding-top:0;">a) 公共建筑主要房间每人所需最小新风量应符合下表的规定:</div>
                            <div class="bottom_tabel">
                                <div class="bottom_tabel_left">
                                    <div class="bottom_tabel_left_title">建筑房间类型</div>
                                    <div>办公室</div>
                                    <div class="back_babel">客房</div>
                                    <div>大堂、四季厅</div>
                                </div>
                                <div class="bottom_tabel_left">
                                    <div class="bottom_tabel_left_title">每人所需最小新风量</div>
                                    <div>30</div>
                                    <div class="back_babel">30</div>
                                    <div>10</div>
                                </div>
                            </div>
                            <div class="bottom_txt">b) 居住建筑设置新风系统时，宜具备良好气密性，所需最小新风量宜按换气次数法确认，设计最小换气次数见下表:</div>
                            <div class="bottom_tabel">
                                <div class="bottom_tabel_left">
                                    <div class="bottom_tabel_left_title">人均居住面积Fp</div>
                                    <div>Fp≤10㎡</div>
                                    <div class="back_babel">10㎡＜Fp≤20㎡</div>
                                    <div>20㎡＜Fp≤50㎡</div>
                                    <div class="back_babel">Fp＞50㎡</div>
                                </div>
                                <div class="bottom_tabel_left">
                                    <div class="bottom_tabel_left_title">每小时换气次数</div>
                                    <div>0.70</div>
                                    <div class="back_babel">0.60</div>
                                    <div>0.50</div>
                                    <div class="back_babel">0.45</div>
                                </div>
                            </div>
                        </div>
                        <!-- <img src="~@/assets/images/fter.png" alt=""> -->
                    </div>
                </div>
            </div>
            <div class="footer">
                <div>
                    <p>
                        * 设计依据：T/CECA-G0095
                        《空气源热泵和燃气热水炉复合能源智能舒适系统技术规范》
                    </p>
                </div>
            </div>
        </div>
        <!-- :ref="'p8index'+index" v-for="(item,index) in objOffer.arrGroud" :key="index" -->
        <div :class="['headder','content_p8'+index]" v-if="false">
            <div class="head_title">设备清单</div>
            <div class="box">
                <div class="nav_borde">
                    <div class="left_bor" v-if="item[0]">
                        <div class="title">主要设备材料清单</div>
                        <div class="leftBor">
                            <div class="tabel_shopp_list">
                                <div class="tabel_shopp_item">
                                    <div class="tabel_shopp_title">
                                        <div style="width:12%;">序号</div>
                                        <div style="width:31%;">名称</div>
                                        <div style="width:12%;">单位</div>
                                        <div style="width:12%;">数量</div>
                                        <div style="width:31%;">备注</div>
                                    </div>
                                    <div class="tabel_shopp_warp" v-for="(items,indexs) in item[0]" :key="indexs">
                                        <div style="width:12%;">{{items.index}}</div>
                                        <div style="width:31%;">{{items.name}}</div>
                                        <div style="width:12%;">{{items.unit==null?'--':items.unit}}</div>
                                        <div style="width:12%;">{{items.num}}</div>
                                        <div style="width:31%;"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right_bor" v-if="item[1]">
                        <div class="title">主要设备材料清单</div>
                        <div class="leftBor">
                            <div class="tabel_shopp_list">
                                <div class="tabel_shopp_item">
                                    <div class="tabel_shopp_title">
                                        <div style="width:12%;">序号</div>
                                        <div style="width:31%;">名称</div>
                                        <div style="width:12%;">单位</div>
                                        <div style="width:12%;">数量</div>
                                        <div style="width:31%;">备注</div>
                                    </div>
                                    <div class="tabel_shopp_warp" v-for="(items,indexs) in item[1]" :key="indexs">
                                        <div style="width:12%;">{{items.index}}</div>
                                        <div style="width:31%;">{{items.name}}</div>
                                        <div style="width:12%;">{{items.unit==null?'--':items.unit}}</div>
                                        <div style="width:12%;">{{items.num}}</div>
                                        <div style="width:31%;"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div>
                    <p>
                        * 设计依据：T/CECA-G0095
                        《空气源热泵和燃气热水炉复合能源智能舒适系统技术规范》
                    </p>
                </div>
            </div>
        </div>
        <div :class="['headder','content_p9'+index]" :ref="'p9index'+index" v-for="(item,index) in objOffer.arrInfoArray" :key="'p9'+index">
            <div class="top-img">{{objOffer.order.show_amount==1?'项目配置清单、报价':'项目配置清单'}}</div>
            <div class="box">
                <div class="bottom-details">
                    <div class="tabel_shopp_list" v-for="(minitem,minindex) in item" :key="minindex">
                        <div class="tabel_shopp_item" v-if="objOffer.order.show_amount==1">
                            <div class="tabel_shopp_title_warp" v-if="minitem.type == 0">{{minitem.step | nNumber}}、{{minitem.type_group_name}}</div>
                            <div class="tabel_shopp_title caet_shopp" v-if="minitem.type == 2">
                                <div style="width:4%;">序号</div>
                                <div style="width:18%;">名称</div>
                                <div style="width:18%;">设备型号</div>
                                <div style="width:20%;">产品描述</div>
                                <div style="width:5%;">单位</div>
                                <div style="width:5%;">数量</div>
                                <div style="width:6%;">单价</div>
                                <div style="width:6%;">合计</div>
                                <div style="width:18%;">备注</div>
                            </div>
                             <!-- v-for="(items,indexs) in minitem.shoppGoods" :key="indexs" -->
                            <div class="tabel_shopp_warp tabel_shopp_warp_xmzj" v-if="minitem.type == 1">
                                <div style="width:4%;">{{minitem.index}}</div>
                                <div style="width:18%;">{{minitem.name}}</div>
                                <div style="width:18%;" v-if="minitem.new_goods_type_id != 201">{{minitem.code}}</div>
                                <!-- {{minitem.sTypeName}}<br>   这部分需要时加载 ==201  里面 -->
                                <div style="width:18%;" v-if="minitem.new_goods_type_id == 201">{{minitem.goods_name}}</div>
                                <div style="width:20%;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{minitem.detail?minitem.detail:'--'}}</div>
                                <div style="width:5%;">{{minitem.unit?minitem.unit:'--'}}</div>
                                <div style="width:5%;">{{minitem.num}}</div>
                                <div style="width:6%;">{{minitem.amount?Number(minitem.amount).toFixed(2):'0'}}</div>
                                <div style="width:6%;">{{(Number(minitem.num)*Number(minitem.amount)).toFixed(2)}}</div>
                                <div style="width:18%;">{{minitem.mark?minitem.mark:'--'}}</div>
                            </div>
                            <div class="tabel_shopp_warp" v-if="minitem.type == 3&&minindex!=item.length-1">
                                <div style="width:4%;"></div>
                                <div style="width:78.9%;">
                                    <div style="width:22%;padding:0;font-weight: 700;">小计</div>
                                    <div style="width:78%;padding:0;"></div>
                                </div>
                                <div style="width:17.9%;font-weight: 700;">{{minitem.minAmount}}元</div>
                            </div>
                            <div class="tabel_shopp_warp" v-if="index==objOffer.arrInfoArray.length-1&&minindex==item.length-1">
                                <div style="width:4%;"></div>
                                <div style="width:78.9%;">
                                    <div style="width:22%;padding:0;font-weight: 700;">总计</div>
                                    <div style="width:78%;padding:0;"></div>
                                </div>
                                <div style="width:17.9%;font-weight: 700;">{{objOffer.numAmount}}元</div>
                            </div>
                        </div>
                        <div class="tabel_shopp_item" v-if="objOffer.order.show_amount==0">
                            <div class="tabel_shopp_title_warp" v-if="minitem.type == 0">{{minitem.step | nNumber}}、{{minitem.type_group_name}}</div>
                            <div class="tabel_shopp_title caet_shopp" v-if="minitem.type == 2">
                                <div style="width:4%;">序号</div>
                                <div style="width:18%;">名称</div>
                                <div style="width:18%;">设备型号</div>
                                <div style="width:20%;">产品描述</div>
                                <div style="width:11%;">单位</div>
                                <div style="width:11%;">数量</div>
                                <div style="width:18%;">备注</div>
                            </div>
                            <div class="tabel_shopp_warp tabel_shopp_warp_xmzj" v-if="minitem.type == 1">
                                <div style="width:4%;">{{minitem.index}}</div>
                                <div style="width:18%;">{{minitem.name}}</div>
                                <div style="width:18%;" v-if="minitem.new_goods_type_id != 201">{{minitem.code}}</div>
                                <!-- {{minitem.sTypeName}}<br>   这部分需要时加载 ==201  里面 -->
                                <div style="width:18%;" v-if="minitem.new_goods_type_id == 201">{{minitem.goods_name}}</div>
                                <div style="width:20%;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{minitem.detail?minitem.detail:'--'}}</div>
                                <div style="width:11%;">{{minitem.unit?minitem.unit:'--'}}</div>
                                <div style="width:11%;">{{minitem.num}}</div>
                                <div style="width:18%;">{{minitem.mark?minitem.mark:'--'}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div>
                    <p>
                        * 设计依据：T/CECA-G0095
                        《空气源热泵和燃气热水炉复合能源智能舒适系统技术规范》
                    </p>
                </div>
            </div>
        </div>
        <div class="content content_p10" ref="p10index" v-for="(item,index) in 1" :key="'p10'+index" v-show="reportObj.third_img_url">
            <div class="top-img">定制方案图纸</div>
            <div class="box-top-img">
                <div class="bottom-p10">
                    <div class="title">
                        <span></span> {{reportObj.address}}
                    </div>
                    <div class="details" v-if="reportObj.third_img_url">
                        <img :src="reportObj.third_img_url" alt="">
                    </div>
                    <div class="details-else">
                        *扫码查看三维施工方案
                    </div>
                </div>
            </div>
        </div>
        <div :class="['headder','content_p11'+index]" :ref="'p11index'+index" v-for="(item,index) in reportObj.goods_album" :key="'p11'+index">
            <div class="top-img">{{item.title}}</div>
            <div class="box-top-img">
                <div class="bottom-p10" style="height:auto;">
                    <div class="title" v-if="item.imgname">
                        <span></span> {{item.imgname}}
                    </div>
                    <div class="details" v-if="item.img">
                        <img :src="item.img" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="content content_p12" style="background: transparent !important;" ref="p12index" v-for="(item,index) in 1" :key="'p12'+index">
            <div class="box-img">
                <img src="~@/assets/images/df_icon.jpg" alt="" width="100%">
            </div>
        </div>
        <!-- loading -->
        <loading :bLoading="bLoading" :nLoading="nLoading"></loading>
    </div>
</template>
<script>
import html2canvas from "html2canvas";
import detail from "@/js/detail.js";
import oFrom from "@/js/form.js";
import loading from "./components/loading/index.vue";
export default {
    components:{
        loading
    },
    data() {
        return {
            bLoading:true,// 是否显示loading
            img_pre:'',//
            nLoading:0,
            reportObj: {
                sub: [],
                arrGroud:[
                    [[],[]],
                    [[],[]]
                ]
            },
            progressTime:null,
            arrImg:[],
            objOffer:[],
            arrImgIndex:0,
            arrOpiten: [
                { className: "content_p0", refName: "p0index" },
                { className: "content_p1", refName: "p1index" },
                { className: "content_p2", refName: "p2index" },
            ],
            bGender:1,//先生还是女士
        };
    },
    filters: {
        roomNumber(index) {
            let arr = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
            if (index < 0) {
                return "地下室" + arr[Number(-index) - 1] + "层";
            } else if (index <= 10 && index > 0) {
                return arr[Number(index) - 1] + "层";
            }
        },
        nNumber(index) {
            let arr = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
            if (index <= 10 && index > 0) {
                return arr[Number(index) - 1];
            }
        },
        nDirection(index){
            let sDirection = '';
            switch (index) {
                case 0:
                    sDirection = '南';
                    break;
                case 1:
                    sDirection = '北';
                    break;
                case 2:
                    sDirection = "东";
                    break;
                case 3:
                    sDirection = "西";
                    break;
                case 4:
                    sDirection = "东南";
                    break;
                case 5:
                    sDirection = "西南";
                    break;
                case 6:
                    sDirection = "东北";
                    break;
                case 7:
                    sDirection = "西北";
                    break;
                case 9:
                    sDirection = "无/未知";
                    break;
            }
            return sDirection
        },
    },
    created() {
        $init((res) => {
            this.getReportinfo();
        });
    },
    methods: {
        //报价单
        getCheck() {
            let that = this;
            let nIndex = 1;
            detail.getCheck({ report_id: that.$route.query.reportId }).then((res) => {
                let objOffer = res.result;
                objOffer.arrInfo = [];
                objOffer.arrGoods = [];
                objOffer.arrInfoGoods = [];
                objOffer.numAmount = 0;//总计
                objOffer.info.forEach((it, index) => {
                    it.info.type = 0;
                    let minAmount = 0;//小计
                    it.arrShopGoods = [];
                    objOffer.arrInfoGoods.push(it.info);//把分类也变成循环数据
                    objOffer.arrInfoGoods.push({type:2});//把是否是要tabel变成循环数据
                    if (it.goods.length != 0) {
                        it.goods.forEach(its=>{
                            its.type = 1;
                            its.index = nIndex;
                            its.info=it.info;
                            minAmount = ((Number(its.amount)*Number(its.num)) + Number(minAmount)).toFixed(2);
                            objOffer.numAmount = ((Number(its.amount)*Number(its.num)) + Number(objOffer.numAmount)).toFixed(2);
                            nIndex++;
                            objOffer.arrInfo.push(its);
                            objOffer.arrInfoGoods.push(its);
                        })
                    }
                    objOffer.arrInfoGoods.push({type:3,minAmount:minAmount});//把小计变成循环数据
                });
                objOffer.groupedArray = that.group(objOffer.arrInfo, 8);
                objOffer.arrInfoArray = that.group(objOffer.arrInfoGoods,21);
                // objOffer.arrGroud = that.group(objOffer.groupedArray, 2);
                // objOffer.arrGroud.forEach((it,index)=>{
                //     that.arrOpiten.push({className: `content_p8${index}`, refName: `p8index${index}`})
                // })
                objOffer.groupedArray.forEach((it,index)=>{
                    let arrMoth = [],nFlag = 0;
                    let arrWdy = {
                        info: '',
                        shoppGoods:''
                    }
                    it.forEach(item=>{
                        let a = '';
                        arrMoth.forEach((ia,ian)=>{
                            if (ia.title == item.info.group_type) {
                                nFlag = 1;
                                a = ian;
                                return
                            }
                        })
                        if (nFlag == 1) {
                            let b = arrMoth[a];
                            b.shoppGoods.push(item);
                            nFlag = 0;

                        } else if (nFlag == 0) {
                            arrWdy = {};
                            arrWdy.title = item.info.group_type;
                            arrWdy.info = item.info;
                            arrWdy.shoppGoods = new Array();
                            arrWdy.shoppGoods.push(item);
                            arrMoth.push(arrWdy);
                        }
                    })
                    objOffer.arrGoods.push(arrMoth)
                })
                // objOffer.arrGoods.forEach((it,index)=>{
                //     that.arrOpiten.push({className: `content_p9${index}`, refName: `p9index${index}`})
                // })
                objOffer.arrInfoArray.forEach((it,index)=>{
                    that.arrOpiten.push({className: `content_p9${index}`, refName: `p9index${index}`})
                })
                //  console.log("报价单", objOffer);
                that.objOffer = objOffer;
                that.$nextTick(()=>{
                    let unArr = [
                        { className: "content_p10", refName: "p10index" },
                        // { className: "content_p11", refName: "p11index" }
                    ]
                    if(that.reportObj.third_img_url){
                        unArr.forEach(it=>{
                            that.arrOpiten.push(it);
                        })
                        that.reportObj.goods_album.forEach((it,index)=>{
                            that.arrOpiten.push({className: `content_p11${index}`, refName: `p11index${index}`});
                        })
                        that.arrOpiten.push({ className: "content_p12", refName: "p12index" })
                    }else{
                        that.reportObj.goods_album.forEach((it,index)=>{
                            that.arrOpiten.push({className: `content_p11${index}`, refName: `p11index${index}`});
                        })
                        that.arrOpiten.push({ className: "content_p12", refName: "p12index" })
                    }
                    //  console.log(that.arrOpiten)
                    that.htmlToImage(this.arrOpiten[this.arrImgIndex]);
                })
            });
        },
        group(array, subGroupLength) {
            let index = 0;
            let newArray = [];
            while(index < array.length) {
                newArray.push(array.slice(index, index += subGroupLength));
            }
            return newArray;
        },
        //报告详情
        getReportinfo() {
            let that = this;
            let reportData = {
                report_id: that.$route.query.reportId,
                show_sub: 1, //子报告
                show_room: 1, //房间信息
                show_attach: 1, //附件信息
                show_product_type: 1, //产品类型
                show_product: 1, //方案商品
                show_tag: 1, //标签信息
                show_common: 1, //通用信息
                chunk_room_product: 1, //房间数量是否根据风盘拆分
                show_card: 1, //获取名片
                qr_code: 1, //转化二维码
            };
            detail.getReportinfo(reportData).then((res) => {
                let obj = res.result;
                //附件循环push到固定轮播图前面
                obj.goods_album.forEach((item) => {
                    item.imgname = "";
                    item.title = '系统原理图'
                });
                obj.attach.forEach((item) => {
                    obj.goods_album.unshift({
                        img: item.items[0],
                        imgname: item.name,
                        title: '平面施工图',
                    });
                });
                //  console.log(obj.goods_album)
                //人员需求是否选择老人小孩女士
                let arrPersonnel = obj.config_ids.split(",");
                let strPersonnel = '';
                arrPersonnel.forEach(it=>{
                    if(it==109){
                        that.bGender = 1;
                    }
                    if(it==110){
                        that.bGender = 0;
                    }
                    if(it==55){
                        if(strPersonnel==''){
                            strPersonnel = '高龄老人'
                        }else{
                            strPersonnel = strPersonnel + '、高龄老人'
                        }
                    }else if(it==56){
                        if(strPersonnel==''){
                            strPersonnel = '体弱女性'
                        }else{
                            strPersonnel = strPersonnel + '、体弱女性'
                        }
                    }else if(it==57){
                        if(strPersonnel==''){
                            strPersonnel = '年幼儿童'
                        }else{
                            strPersonnel = strPersonnel + '、年幼儿童'
                        }
                    }
                });
                obj.nPercentNum = 0;
                obj.nWaterSoft = 0;
                obj.nWaterClean = 0;
                obj.nWaterEnergy = 0;
                obj.nWaterRate = 0;
                obj.numToilet = 0;
                obj.numKitchen = 0;
                obj.numWindKou = 0;
                obj.numWindArea = 0;
                obj.numHqcs = 0;
                obj.numFreshs = 0;
                obj.hotOrcatArea = 0;
                obj.roomsArea = 0;
                obj.arrCodsystem = [];
                obj.arrAilink = [];
                obj.arrWater = [];
                obj.arrFater = [];
                obj.arrRooms = [];
                obj.endRoom_hot = 0;//总需求热负荷
                obj.endRoom_cut = 0;//总需求冷负荷
                obj.arrGoodsFater = [];
                obj.arrRoomsThree = [];
                let arrEndRoomShopp = [];
                obj.arrRoomEnd = [];
                obj.sub.forEach((sub) => {
                    sub.numWindKou = 0;
                    sub.arrSubFater = [];
                    obj.nPercentNum = Number(sub.energy_percent) + Number(obj.nPercentNum);
                    obj.nWaterSoft = Number(sub.water_soft) + Number(obj.nWaterSoft);
                    obj.nWaterClean = Number(sub.water_clean) + Number(obj.nWaterClean);
                    obj.nWaterEnergy = Number(sub.water_energy) + Number(obj.nWaterEnergy);
                    obj.nWaterRate = Number(sub.water_rate) + Number(obj.nWaterRate);
                    sub.product.forEach((product) => {
                        if (product.level == 0) {
                            product.items.forEach((items) => {
                                if (items.system_id == 1) {
                                    items.items.forEach((itemstwo) => {
                                        itemstwo.items.forEach((itemsthree) => {
                                            itemsthree.attr_one = []; // 右边重要卖点
                                            itemsthree.attr_two = []; // 下面参数
                                            itemsthree.attr_three = []; //末端选项参数
                                            itemsthree.attr.forEach((ib) => {
                                                ib.attr_name = ib.attr_name
                                                    .replace(/[\r\n]/g, "")
                                                    .replace(/\ +/g, ""); // 过滤空格、换行
                                                ib.attr_value = ib.attr_value
                                                    ? ib.attr_value.replace(/[\r\n]/g, "").replace(/\ +/g, "")
                                                    : ""; // 过滤空格、换行
                                                if (ib.attr_mean <= 3) {
                                                    // 右边重要卖点分离
                                                    itemsthree.attr_one.push(ib);
                                                }
                                                if (ib.attr_mean > 3) {
                                                    // 下面参数分离
                                                    itemsthree.attr_three.push(ib);
                                                }
                                                if (
                                                    (ib.attr_name == "制热量" ||ib.attr_name == "制冷量")
                                                ) {
                                                    // 下面参数分离
                                                    itemsthree.attr_two.push(ib);
                                                }
                                            })
                                            if(itemsthree.new_goods_type_id==215||itemsthree.new_goods_type_id==216){
                                                }else{
                                                obj.arrCodsystem.push(itemsthree);
                                                if(itemsthree.new_goods_type_id!=214){
                                                    obj.arrAilink.push(itemsthree)
                                                }
                                            }
                                        });
                                    });
                                }
                                if (items.system_id == 4 || items.system_id == 2) {
                                    items.items.forEach((itemstwo) => {
                                        itemstwo.items.forEach((itemsthree) => {
                                            itemsthree.attr_one = []; // 右边重要卖点
                                            itemsthree.attr_two = []; // 下面参数
                                            itemsthree.attr_three = []; //末端选项参数
                                            itemsthree.attr.forEach((ib) => {
                                                ib.attr_name = ib.attr_name
                                                    .replace(/[\r\n]/g, "")
                                                    .replace(/\ +/g, ""); // 过滤空格、换行
                                                ib.attr_value = ib.attr_value
                                                    ? ib.attr_value.replace(/[\r\n]/g, "").replace(/\ +/g, "")
                                                    : ""; // 过滤空格、换行
                                                if (ib.attr_mean <= 3) {
                                                    // 右边重要卖点分离
                                                    itemsthree.attr_one.push(ib);
                                                }
                                                if (ib.attr_mean > 3) {
                                                    // 下面参数分离
                                                    itemsthree.attr_three.push(ib);
                                                }
                                                if (
                                                    ib.attr_mean > 3 &&
                                                    (ib.attr_name == "热水输出功率" ||ib.attr_name == "流量")
                                                ) {
                                                    // 下面参数分离
                                                    itemsthree.attr_two.push(ib);
                                                }
                                            })
                                            obj.arrWater.push(itemsthree);
                                        });
                                    });
                                }
                                if (items.system_id == 3) {
                                    items.items.forEach((itemstwo) => {
                                        itemstwo.items.forEach((itemsthree) => {
                                            itemsthree.attr_one = []; // 右边重要卖点
                                            itemsthree.attr_two = []; // 下面参数
                                            itemsthree.attr_three = []; //末端选项参数
                                            itemsthree.attr.forEach((ib) => {
                                                ib.attr_name = ib.attr_name
                                                    .replace(/[\r\n]/g, "")
                                                    .replace(/\ +/g, ""); // 过滤空格、换行
                                                ib.attr_value = ib.attr_value
                                                    ? ib.attr_value.replace(/[\r\n]/g, "").replace(/\ +/g, "")
                                                    : ""; // 过滤空格、换行
                                                if (ib.attr_mean <= 3) {
                                                    // 右边重要卖点分离
                                                    itemsthree.attr_one.push(ib);
                                                }
                                                if (ib.attr_mean > 3) {
                                                    // 下面参数分离
                                                    itemsthree.attr_three.push(ib);
                                                }
                                                if (
                                                    (ib.attr_name == "热回收率" || ib.attr_name == "风量"|| ib.attr_name == "新风PM2.5过滤效率（%）")
                                                ) {
                                                    // 下面参数分离
                                                    itemsthree.attr_two.push(ib);
                                                }
                                            })
                                            sub.numWindKou = sub.numWindKou +=itemsthree.num;
                                            sub.arrSubFater.push(itemsthree)
                                            itemsthree.room = sub.room;
                                            itemsthree.numWindKou = sub.numWindKou;
                                            itemsthree.wind_area = sub.wind_area;
                                            itemsthree.wind_exchange = sub.wind_exchange;
                                            itemsthree.wind_energy = sub.wind_energy;
                                            obj.arrFater.push(itemsthree);
                                        });
                                    });
                                }
                            });
                        }
                    });
                    obj.arrStrFater = that.group(obj.arrFater, 2);
                    sub.rooms.forEach(it=>{
                        it.room = sub.room
                        let arr = it.product.filter(its=>{
                            return its.new_goods_type_id == 201
                        })
                        if(arr.length){
                            obj.endRoom_hot = obj.endRoom_hot += it.energy_hot;
                            obj.endRoom_cut = obj.endRoom_cut += it.energy_cold;
                            obj.hotOrcatArea += Number(it.area);
                        }
                        obj.roomsArea += Number(it.area);
                        it.product.forEach(sh=>{
                            sh.roomName = it.name;
                            sh.room = sub.room;
                            sh.area = it.area;
                            sh.direction = it.direction;
                            sh.floor = it.floor;
                            sh.temperature = it.temperature;
                            sh.energy_cold = it.energy_cold;
                            sh.energy_hot = it.energy_hot;
                            sh.attr_one = []; // 右边重要卖点
                            sh.attr_two = []; // 下面参数
                            sh.attr_three = []; //末端选项参数
                            sh.attr.forEach((ib) => {
                                ib.attr_name = ib.attr_name
                                    .replace(/[\r\n]/g, "")
                                    .replace(/\ +/g, ""); // 过滤空格、换行
                                ib.attr_value = ib.attr_value
                                    ? ib.attr_value.replace(/[\r\n]/g, "").replace(/\ +/g, "")
                                    : ""; // 过滤空格、换行
                                if (ib.attr_mean <= 3) {
                                    // 右边重要卖点分离
                                    sh.attr_one.push(ib);
                                }
                                if (ib.attr_mean > 3) {
                                    // 下面参数分离
                                    sh.attr_three.push(ib);
                                }
                                if (
                                    // ib.attr_mean > 3 &&
                                    (ib.attr_name == "供冷量" ||ib.attr_name == "供热量" || ib.attr_name == "散热量W80/60/20℃")
                                ) {
                                    // 下面参数分离
                                    sh.attr_two.push(ib);
                                }
                            })
                            arrEndRoomShopp.push(sh);
                        })
                        if(it.product.length){
                            obj.arrRooms.push(it);
                            obj.arrRoomsThree.push(it);
                        }
                    })
                    obj.numFreshs = obj.numFreshs += Number(sub.wind_energy);
                    obj.numHqcs = obj.numHqcs += Number(sub.wind_exchange);
                    obj.numToilet = obj.numToilet += Number(sub.num_toilet);
                    obj.numKitchen = obj.numKitchen += Number(sub.num_kitchen);
                    obj.numWindArea = obj.numWindArea += Number(sub.wind_area);
                });
                obj.arrStrFater.forEach(it=>{
                    let arrMoth = [],nFlag = 0,arrMothGoods = [];
                    let arrWdy = {
                        info: '',
                        shoppGoods:''
                    }
                    it.forEach(item=>{
                        let a = '';
                        arrMoth.forEach((ia,ian)=>{
                            if (ia.room == item.room) {
                                nFlag = 1;
                                a = ian;
                                return
                            }
                        })
                        if (nFlag == 1) {
                            let b = arrMoth[a];
                            b.shoppGoods.push(item);
                            nFlag = 0;

                        } else if (nFlag == 0) {
                            arrWdy = {};
                            arrWdy.title = item.room;
                            arrWdy.room = item.room;
                            arrWdy.numWindKou = item.numWindKou;
                            arrWdy.wind_area = item.wind_area;
                            arrWdy.wind_exchange = item.wind_exchange;
                            arrWdy.wind_energy = item.wind_energy;
                            arrWdy.shoppGoods = new Array();
                            arrWdy.shoppGoods.push(item);
                            arrMoth.push(arrWdy);
                        }
                        arrMothGoods.push(item)
                    })
                    obj.arrGoodsFater.push({arrMoth:arrMoth,arrMothGoods:arrMothGoods})
                })
                //  console.log('新风',obj.arrGoodsFater)
                obj.arrSubFater = obj.sub.filter(it=>{
                    return it.arrSubFater.length != 0;
                })
                obj.tags.forEach((tag) => {
                    tag.arrDeas = [];
                    tag.arrWater = []; //水系统里面的人员需求
                    tag.arrFreshs = []; //新风系统的人员需求
                    tag.arrAilink = []; //ailink的人员需求
                    tag.arrXiaji = []; //冬季需求
                    tag.arrHuasa = []; //水系统里面的花洒
                    tag.name = "";
                    tag.nameClass = "";
                    if (tag.type == 1) {
                        tag.name = "作息需求";
                        tag.nameClass = "two_icon";
                        tag.items.forEach((des) => {
                            if (des.desc != "") {
                                tag.arrDeas.push("*" + des.desc);
                                tag.tag_id = 0;
                            }
                            if (des.desc != "" && des.tag_id == 31) {
                                obj.warm_state_text = des.name;
                            }
                        });
                        //拼接文字
                        let strDeas = this.arrStr(tag.arrDeas, "<br/>");
                        tag.strDeas = strDeas;
                    }
                    if (tag.type == 2) {
                        tag.name = "人员需求";
                        tag.nameClass = "one_icon";
                        tag.items.forEach((des) => {
                            if (des.desc != "") {
                                if(des.tag_id == 33){
                                    des.desc = des.desc+'，家中有'+strPersonnel;
                                }
                                tag.arrDeas.push("*" + des.desc);
                                tag.tag_id = 0;
                            }
                        });
                        //拼接文字
                        let strDeas = this.arrStr(tag.arrDeas, "<br/>");
                        tag.strDeas =
                            strDeas +
                            "为了保证身体健康，冬季需要更温暖的室内环境";
                    }
                    if (tag.type == 5) {
                        tag.name = "冬季室温需求";
                        tag.nameClass = "three_icon";
                        tag.items.forEach((des) => {
                            if (des.desc != "") {
                                tag.arrDeas.push("*" + des.desc);
                                tag.tag_id = 0;
                            }
                        });
                        //拼接文字
                        let strDeas = this.arrStr(tag.arrDeas, "<br/>");
                        tag.strDeas = strDeas;
                    }
                    if (tag.type == 4) {
                        tag.name = "夏季室温需求";
                        tag.nameClass = "four_icon";
                        tag.items.forEach((des) => {
                            if (des.desc != "") {
                                tag.arrDeas.push("*" + des.desc);
                                tag.tag_id = 0;
                            }
                        });
                        //拼接文字
                        let strDeas = this.arrStr(tag.arrDeas, "<br/>");
                        tag.strDeas = strDeas;
                    }
                    if (tag.type == 3) {
                        tag.name = "人员需求";
                        tag.nameClass = "one_icon";
                        tag.items.forEach((des) => {
                            if (des.desc != "") {
                                tag.arrDeas.push("*" + des.desc);
                                tag.tag_id = 0;
                            }
                        });
                        //拼接文字
                        let strDeas = this.arrStr(tag.arrDeas, "<br/>");
                        tag.strDeas = strDeas;
                    }
                    // if (tag.type == 3) {
                    //     tag.name = "人员需求";
                    //     tag.nameClass = "one_icon";
                    //     //拼接文字
                    //     tag.items.forEach((des) => {
                    //         if (des.desc != "" && des.id == 64) {
                    //             tag.arrDeas.push("*" + des.desc);
                    //             tag.tag_id = des.id;
                    //         }
                    //         if (des.desc != "") {
                    //             tag.arrDeas.push("*" + des.desc);
                    //             tag.tag_freshs_id = des.id;
                    //         }
                    //         if (des.desc != "" && des.id == 65) {
                    //             tag.arrDeas.push("*" + des.desc);
                    //             tag.tag_ailink_id = des.id;
                    //         }
                    //         if (des.desc != "" && des.id == 83) {
                    //             tag.arrDeas.push("*" + des.desc);
                    //             // tag.tag_ailink_id = des.id;
                    //         }
                    //         if (des.desc != "" && des.id == 108) {
                    //             tag.arrHuasa.push("*" + des.desc);
                    //             tag.tag_huasa_id = des.id;
                    //         }
                    //     });
                    //     //拼接文字
                    //     let strHuasa = this.arrStr(tag.arrHuasa, "<br/>");
                    //     let strDeas = this.arrStr(tag.arrWater, "<br/>");
                    //     let strDeasFreshs = this.arrStr(tag.arrFreshs, "<br/>");
                    //     let strDeasAilink = this.arrStr(tag.arrAilink, "<br/>");
                    //     if (strDeasAilink == "") {
                    //         this.bShowText = false;
                    //     }
                    //     if (strDeasFreshs == "") {
                    //         this.bShowFreshsText = false;
                    //     }
                    //     if (strDeas == "") {
                    //         this.bShowWaterText = false;
                    //     }
                    //     tag.strHuasa = strHuasa;
                    //     tag.strDeas = strDeas;
                    //     tag.strDeasFreshs = strDeasFreshs;
                    //     tag.strDeasAilink = strDeasAilink;
                    // }
                });
                obj.arrCodsystem = this.noRepeat(obj.arrCodsystem);
                obj.arrQuanWater = [];
                obj.arrWater.forEach(it=>{
                    if(it.num==1){
                        obj.arrQuanWater.push(it)
                    }else{
                        for(let i=0;i<it.num;i++){
                            obj.arrQuanWater.push(it)
                        }
                    }
                })
                obj.arrRooms = that.group(obj.arrRooms, 4);
                arrEndRoomShopp = that.group(arrEndRoomShopp,12);
                obj.arrRoomsThree = that.group(obj.arrRoomsThree, 6)
                let arrone = [
                    { className: "content_p4", refName: "p4index" },
                ]
                let arrtwo = [
                    { className: "content_p6", refName: "p6index" },
                ]
                //末端配置
                arrEndRoomShopp.forEach(it=>{
                    let arrMoth = [],nFlag = 0;
                    let arrWdy = {
                        name: '',
                        shoppGoods:'',
                        room:'',
                        area:'',
                        direction:'',
                        floor:'',
                        temperature:'',
                    }
                    it.forEach(item=>{
                        let a = '';
                        arrMoth.forEach((ia,ian)=>{
                            if (ia.title == item.roomName+item.room) {
                                nFlag = 1;
                                a = ian;
                                return
                            }
                        })
                        if (nFlag == 1) {
                            let b = arrMoth[a];
                            b.shoppGoods.push(item);
                            nFlag = 0;

                        } else if (nFlag == 0) {
                            arrWdy = {};
                            arrWdy.title = item.roomName+item.room;
                            arrWdy.name = item.roomName;
                            arrWdy.room = item.room;
                            arrWdy.area = item.area;
                            arrWdy.direction = item.direction;
                            arrWdy.floor = item.floor;
                            arrWdy.temperature = item.temperature;
                            arrWdy.energy_cold = item.energy_cold;
                            arrWdy.energy_hot = item.energy_hot;
                            arrWdy.shoppGoods = new Array();
                            arrWdy.shoppGoods.push(item);
                            arrMoth.push(arrWdy);
                        }
                    })
                    obj.arrRoomEnd.push(arrMoth)
                })
                obj.arrRoomEnd.forEach((it,index)=>{
                    that.arrOpiten.push({className: `content_p3${index}`, refName: `p3index${index}`})
                })
                // arrone.forEach(it=>{
                //     that.arrOpiten.push(it)
                // })
                // obj.arrRoomsThree.forEach((it,index)=>{
                //     that.arrOpiten.push({className: `content_p5${index}`, refName: `p5index${index}`})
                // })
                arrtwo.forEach(it=>{
                    that.arrOpiten.push(it)
                })
                obj.arrGoodsFater.forEach((sub,index) => {
                    that.arrOpiten.push({ className: `content_p7${index}`, refName: `p7index${index}` },)
                });
                that.reportObj = obj;
                //  console.log(obj)
                that.getCheck();
            });
        },
        //商品去重
        noRepeat(arr) {
            for (var i = 0; i < arr.length; i++) {
                for (var j = i + 1; j < arr.length; j++) {
                    if (arr[i].goods_name == arr[j].goods_name) {
                        arr[i].num = arr[i].num+arr[j].num;
                        arr.splice(j, 1);
                        j--;
                    }
                }
            }
            return arr;
        },
        //拼接字符
        arrStr(arr, connectStr) {
            var str = "";
            let nStar = 0;
            //遍历数组
            arr.forEach((ele) => {
                nStar++;
                if (nStar == arr.length) {
                    str += ele;
                } else {
                    str += ele + String(connectStr);
                }
            });
            return str;
        },
        //生成长图
        htmlToImage(it) {
            let that = this;
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            let sHeight =
                document.querySelector(`.${it.className}`).offsetHeight - 70;
            let sWidth = document.querySelector(`.${it.className}`).offsetWidth;
            let scale = 1;
            let name = it.refName;
            //  console.log(it.refName)
            html2canvas(that.$refs[name][0], {
                useCORS: true,
                // backgroundColor:null,
                height: sHeight,
                width: sWidth,
                // dpi: window.devicePixelRatio,
                scale: scale,
                dpi:300,
            })
                .then((canvas) => {
                    let sUrl = canvas.toDataURL("image/jpg",1);
                    oFrom.uploadImg({file:sUrl}).then(res=>{
                        if(this.arrImgIndex >= 1){
                            this.arrImg.push(res.data.data.result.local_url);
                        }else{
                            this.img_pre = res.data.data.result.local_url;
                        }
                        this.arrImgIndex++;
                        if(this.arrImgIndex>this.arrOpiten.length-1){
                            let data={
                                report_id:that.$route.query.reportId,
                                img_pre:this.img_pre,

                                imgs:this.arrImg.join(','),
                            }
                            detail.getPdf(data).then(res=>{
                                this.nLoading = 100;
                                clearInterval(that.progressTime);
                                setTimeout(()=>{
                                    this.$router.push({
                                        path: `/pdf/sharepdf?reportId=${this.$route.query.reportId}`,
                                    });
                                },500)
                            })
                        }else{
                            if(that.progressTime==null){
                                that.progressTime = setInterval(() => {
                                    let nNum = Math.floor(Math.random() * (2 - 1 + 1) + 1);
                                    this.nLoading += nNum;
                                    if (this.nLoading >= 99) {
                                        this.nLoading = 99;
                                    }
                                }, 1500);
                            }
                            this.htmlToImage(this.arrOpiten[this.arrImgIndex])
                        }
                    })
                })
                .catch((fail) => {
                    that.$toast("图片上传失败");
                    //  console.log(fail);
                });
        },
    },
};
</script>
<style lang="scss" scoped>
@import "pdfindex.scss";
</style>
